import React from 'react';
import { Field, reduxForm } from 'redux-form';

import SingleColumn from '$ContainersLegacy/SingleColumn';
import TextFieldCSS from '$Fields/TextField/TextField-css';
import { IntlMessage } from '$HVUI';
import Button from '$Molecules/Buttons/Button';
import FormButton from '$Molecules/Buttons/FormButton';
import { isEmail, notEmpty } from '$Validation/i18n-validator';

export class ForgotPasswordForm extends React.Component {
    render() {
        const {
            handleSubmit,
            forgotPasswordEmail,
            invalid,
            submitting,
            submitSucceeded
        } = this.props;
        if (submitSucceeded) {
            return (
                <div>
                    <h2
                        style={{
                            marginTop: '32px',
                            fontSize: '1.375em',
                            fontWeight: '400'
                        }}
                    >
                        <IntlMessage
                            id="forgot-password.password-reset-sent-to"
                            defaultMessage="Password reset sent to {email}"
                            values={{ email: forgotPasswordEmail }}
                        />
                    </h2>
                    <h2 style={{ fontSize: '1.375em', fontWeight: '400' }}>
                        <IntlMessage
                            id="forgot-password.please-check-your-inbox-for"
                            defaultMessage="Please check your email inbox for further instructions"
                        />
                    </h2>
                    <Button
                        style={{ marginTop: 32 }}
                        kind="secondary"
                        text={
                            <IntlMessage
                                id="forgot-password.return-to-home"
                                defaultMessage="Return to Home"
                            />
                        }
                        element="Link4"
                        to="/logout"
                    />
                </div>
            );
        }
        return (
            <SingleColumn marginTop={48} marginBottom={72}>
                <form
                    onSubmit={handleSubmit}
                    className="forgot-form-wrapper"
                    data-complete={!invalid && !submitting}
                >
                    <Field
                        name="email"
                        component={TextFieldCSS}
                        data={{
                            label: (
                                <IntlMessage
                                    id="forgot-password.email-address"
                                    defaultMessage="Email Address"
                                />
                            )
                        }}
                        validate={[notEmpty, isEmail]}
                    />
                    <FormButton center element="button" {...this.props} />
                </form>
            </SingleColumn>
        );
    }
}

export default reduxForm({
    form: 'ForgotPasswordForm'
})(ForgotPasswordForm);
